import { app } from '../../../app';
import { Controller } from './license-violation.controller';

app.component('companyLicenseViolation', {
    bindings: {
        companyId: '<',
        licenseViolations: '<',
    },
    controller: Controller,
    templateUrl: require('./license-violation.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-violation/license-violation.component.js